import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const fetchCustomerReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/report/customer-report`, {
      params: {
        fromDate,
        toDate,
        page,
        limit: rowsPerPage, // use 'limit' for rows per page
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};

export const fetchCustomerPigmyReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  search,
  isExcelData
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/report/pigmy-report`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        rowsPerPage,
        frequency,
        status,
        agent,
        search,
        isExcelData,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const fetchCustomerPigmyCollectionReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  isExcelData,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/pigmy-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          rowsPerPage,
          frequency,
          status,
          agent,
          isExcelData,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};

export const fetchCustomerLoanReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  isExcelData,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/report/loan-report`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        rowsPerPage,
        frequency,
        status,
        agent,
        isExcelData,
        search,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};

export const fetchCustomerLoanCollectionReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  isExcelData,
  search
) => {
  try {
    console.log(isExcelData);
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/loan-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          frequency,
          status,
          agent,
          isExcelData: isExcelData,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const fetchWeeklyReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  collectionDay,
  status,
  agent,
  isExcelData
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/weekly-loan-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          collectionDay,
          status,
          agent,
          isExcelData,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};

export const fetchCustomerGroupLoanReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/report/group-loan-report`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        rowsPerPage,
        frequency,
        status,
        agent,
        search,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const fetchCustomerGroupLoanCollectionReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  isExcelData,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/group-loan-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          frequency,
          status,
          agent,
          isExcelData,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const fetchWeeklyGroupReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  collectionDay,
  status,
  agent,
  isExcelData
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/weekly-group-loan-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          collectionDay,
          status,
          agent,
          isExcelData,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};

export const fetchCustomerGroupPigmyReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/report/group-pigmy-report`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        rowsPerPage,
        frequency,
        status,
        agent,
        search,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};

export const fetchCustomerGroupPigmyCollectionReportService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  frequency,
  status,
  agent,
  isExcelData,
  search
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/report/group-pigmy-collection-report`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          frequency,
          status,
          agent,
          isExcelData,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
